import dayjs from 'dayjs';
import React, { useContext, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import fileDownload from 'services/fileDownload';
import { stahnoutFakturu } from 'services/lei/leiPlatba';

const Faktury: React.FC = () => {
    const { lei } = useContext(Context);
    const [loading, setLoading] = useState<boolean>(false);

    const columns = [
        {
            title: <TranslateText>DATUM</TranslateText>,
            key: 'datum',
            dataIndex: 'datum',
            render: (datum: string | null | undefined) => {
                return dayjs(datum).format('DD.MM.YYYY');
            }
        },
        /* {
           
            title: <TranslateText>EMP_PODANE_ZADOSTI_STAV</TranslateText>,
            key: 'stav',
            dataIndex: 'stav',
            render: () => <TranslateText>REGISTRACNI_POPLATEK</TranslateText>
 
        },*/
        {
            dataIndex: 'nazev',
            key: 'nazev',
            width: 120,
            render: (nazev: string, _b: unknown, index: number) => (
                <AnchorComponent
                    id={`fakturyLeiZobrazitBtn${index}`}
                    onClick={() => {
                        setLoading(true);
                        stahnoutFakturu(lei?.idVarsymZadosti?.varsym || '', nazev)
                            .then(data => fileDownload(encodeURIComponent(data.redirect)))
                            .finally(() => setLoading(false));
                    }}
                >
                    <TranslateText>ZOBRAZIT</TranslateText>
                </AnchorComponent>
            )
        }
    ];

    return (
        <LoadingWrapper loading={loading}>
            <Title level={3} text="LEI_VYSTAVENE_FAKTURY" />
            <TableComponent
                columns={columns}
                dataSource={
                    lei?.detailData?.fakturace
                        ? lei?.detailData?.fakturace.sort((a, b) => (dayjs(a.datum) > dayjs(b.datum) ? -1 : 1))
                        : []
                }
                loading={loading}
                locale={{
                    emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                }}
            />
        </LoadingWrapper>
    );
};

export default Faktury;
